import {
  getCurrentWorkoutSelect,
  getIdReduxUtil,
  loadInstanceReduxAction
} from '@gymaholic/packages'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import {
  interpolateStringUtil,
  logUtil
} from 'packages/src'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'
import REDUX_OPTION from 'modules/redux/constants/option.js'
import { WORKOUT_KEY } from 'modules/training/models/workout/constants/index.js'
import { WORKOUTS_ENDPOINT } from 'modules/workout/redux/constants/index.js'

const idToLoadedMap = {}

export default function loadProfilesWhoStartedThisWorkout () {
  return async (dispatch, getState) => {
    const workout = getCurrentWorkoutSelect(getState())
    const id = getIdReduxUtil(workout)
    const logPrefix = `id=${id}`
    try {
      logUtil('loadProfilesWhoStartedThisWorkout').debug(`${logPrefix} [start]`)

      if (idToLoadedMap[id]) {
        logUtil('loadProfilesWhoStartedThisWorkout').debug(`${logPrefix} [noop]`)
        return
      }

      const res = await dispatch(
        loadInstanceReduxAction({
          type: getActionStrReduxUtil(
            REDUX_ACTION_PREFIX.LOAD,
            WORKOUT_KEY.PROFILES_WHO_STARTED
          ),
          payload: {
            endpoint: interpolateStringUtil(
              WORKOUTS_ENDPOINT.PROFILES_WHO_STARTED,
              { id }
            ),
            path: getPathReduxUtil(workout),
            options: {
              [REDUX_OPTION.IS_IMMEDIATE]: true,
              [REDUX_OPTION.IS_FORCED]: true,
              [REDUX_OPTION.NO_AUTH_NEEDED]: true
            }
          }
        })
      )

      idToLoadedMap[id] = true

      logUtil('loadProfilesWhoStartedThisWorkout').debug(`${logPrefix} res=`, res)
    } catch (error) {
      logUtil('loadProfilesWhoStartedThisWorkout').error(`${logPrefix} error=`, error)
    }
  }
}
